import {RouterProvider} from 'react-router-dom'
import {StyleSheetManager, ThemeProvider} from 'styled-components'
import {getAppTheme, GlobalStyles} from '@/theme/theme.ts'
import router from './router.tsx'
import {Toaster} from 'react-hot-toast'
import useWindowDimensions from '@hooks/useWindowDimensions.ts'
import {useMemo} from 'react'

export default function App() {
    const themeName = 'light' //get it from the app reducer
    const {width} = useWindowDimensions()
    const isMobile = useMemo(() => width < 1058, [width])

    return (
        <ThemeProvider theme={getAppTheme({name: themeName})}>
            <StyleSheetManager>
                <>
                    <Toaster position={isMobile ? 'top-center' : 'top-right'} />
                    <GlobalStyles />
                    <RouterProvider router={router} />
                </>
            </StyleSheetManager>
        </ThemeProvider>
    )
}
